import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Container, Button } from 'react-bootstrap';

import PageTitle from '../../../common/PageTitle';
import { getAppClicks, getUserLogins } from "../../../store/actions/reports/reportsActions"
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import AppClicks from './AppClicks';
import UserLogins from './UserLogins';

class UsageStatistics extends Component {

  componentDidMount() {
    this.appClickRef = null;
    this.userLoginsRef = null;
  }

  printChart = (chartRef) => {
    return chartRef ? (
      <div style={{height: 40}}>
        <ReactToPrint 
          content={() => chartRef}
          pageStyle='@page { size: auto; margin: 0mm; } @media print { body { -webkit-print-color-adjust: exact; padding: 60px !important; } }'
        >
          <PrintContextConsumer>
            {({ handlePrint }) => (
              <Button style={{float: 'right'}} size="sm" onClick={handlePrint}>Print Chart</Button>
            )}
          </PrintContextConsumer>
        </ReactToPrint>
      </div>
    ) : null
  }
  
  render() {

    const pageName = this.props.pageName || "REPORTS";

    return (
      <div>
        <Container className="waa-container">
          <PageTitle pageName={pageName} />
          {this.printChart(this.appClicksRef)}
          <div ref={ref => this.appClicksRef = ref}>
            <AppClicks />
          </div>
          {this.printChart(this.userLoginsRef)}
          <div ref={ref => this.userLoginsRef = ref}>
            <UserLogins />
          </div>
        </Container>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  reports: state.reports,
})
const mapDispatchToProps = (dispatch) => ({
  getAppClicks: (...args) => dispatch(getAppClicks(...args)),
  getUserLogins: (...args) => dispatch(getUserLogins(...args))
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UsageStatistics))